import McpConsentService from '@/client/services/api/McpConsentService';
import { useMutation, useQuery } from '@tanstack/react-query';
import { useToastStore } from '@/client/services/state/toastStore';
import { useTranslation } from 'react-i18next';

export const useMcpConsentInfo = (clientId: string | null, enabled: boolean) =>
  useQuery({
    queryKey: ['mcp-consent-info', clientId],
    queryFn: () => McpConsentService.getConsentInfo(clientId as string),
    enabled: enabled && Boolean(clientId),
    retry: false,
  });

export const useMcpMintOauthKey = () => {
  const { setToast } = useToastStore();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: () => McpConsentService.generateOauthKey(),
    onError: () => {
      setToast({
        show: true,
        status: 'error',
        title: t('mcp.consent.mintFailed'),
      });
    },
  });
};
